module.exports = __webpack_public_path__ + "img/item9-3.16015aba.png";